import { useLocation } from "react-router-dom";

import Box from "@/components/Box";
import Page from "@/components/Page";
import Stack from "@/tpo/Stack";
import B2CHeader from "@/tpo/header/B2CHeader";

export default function PaymentSetupRequired({ orderId: orderIdProp }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = orderIdProp ?? searchParams.get("order_id");

  return (
    <>
      <B2CHeader />
      <Page bg="haze" includeFooter addNavBarHeight={true}>
        <Stack
          maxWidth={600}
          mx="auto"
          mt={[110, 110, 180]}
          mb={[40, 40, 180]}
          px={[20, 20, 40]}
          gap={[30, 30, 40]}
          alignItems="center"
          textAlign="center"
        >
          <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
            Unable to complete checkout
          </Box>

          <Stack gap={[20, 20, 24]}>
            <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
              We're sorry, but we are unable to take payment for this order at this time. Please
              contact your healthcare practitioner or info@regeneruslabs.com for assistance.
            </Box>

            {orderId && (
              <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
                Order ID: {orderId}
              </Box>
            )}
          </Stack>
        </Stack>
      </Page>
    </>
  );
}
